import React from 'react';
import { Input } from '@/components/ui/input';
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { cn } from '@/lib/utils';
function TextFieldInner({ id, control, label, name, description, startIcon, endIcon, labelRight, onChange, ...props }) {
    return (<FormField control={control} name={name} render={({ field }) => (<FormItem className={cn('space-y-2', props.className)}>
                    <div className="flex items-center justify-between">
                        {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
                        {labelRight}
                    </div>
                    <FormControl>
                        <div className="relative">
                            {startIcon && startIcon}
                            <Input {...props} {...field} onChange={(event) => {
                field.onChange(event);
                if (onChange) {
                    onChange(event);
                }
            }} name={name} className={cn('w-full', 'focus-visible:border-primary focus-visible:ring-1 focus-visible:ring-primary', startIcon && 'pl-9', endIcon && 'pr-9', props.className)}/>
                            {endIcon && endIcon}
                        </div>
                    </FormControl>
                    <FormMessage />
                    {description && <FormDescription>{description}</FormDescription>}
                </FormItem>)}/>);
}
TextFieldInner.displayName = 'TextField';
export const TextField = React.memo(TextFieldInner);
